import React, { useState } from "react";
import Confirmation from "../../components/register/Confirmation";
import AddPassword from "../../components/register/AddPassword";
import UserForm from "../../components/register/UserForm";
import { Grid, Typography } from "@mui/material";
import "./register.scss";
const Register = () => {
  const [page, setPage] = useState(1);
  const [authToken, setAuthToken] = useState("");

  const next = () => {
    setPage(page + 1);
  };
  const previous = () => {
    setPage(page - 1);
  };

  const renderPage = () => {
    if (page === 1) {
      return <UserForm next={next} setAuthToken={setAuthToken} />;
    } else if (page === 2) {
      return <Confirmation back={previous} next={next} authToken={authToken} />;
    } else if (page === 3) {
      return <AddPassword back={previous} next={next} authToken={authToken} />;
    } else {
      return null;
    }
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        className="register-page"
      >
        <Grid
          container
          direction="column"
          marginTop="3rem"
          padding="1rem"
          width="30%"
          className="main-div"
        >
          <Typography variant="h5" color="color.magentaDark1">
            Step {page} of 3
          </Typography>
          {renderPage()}
        </Grid>
      </Grid>
    </>
  );
};

export default Register;
